

/// <reference path="Tag.ts" />

// Generated class ServiceChargeTag_ManagedObject

class ServiceChargeTag_ManagedObject extends Tag
{

    // Property: orderIndex
    set orderIndex(value:number) {
        this.setValueForKey(value, 'orderIndex');
    }
    get orderIndex():number {
        return this.valueForKey('orderIndex');
    }
    set orderIndexPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'orderIndex');
    }
    get orderIndexPrimitiveValue():number {
        return this.primitiveValueForKey('orderIndex');
    }

    // Property: productID
    set productID(value:string) {
        this.setValueForKey(value, 'productID');
    }
    get productID():string {
        return this.valueForKey('productID');
    }
    set productIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'productID');
    }
    get productIDPrimitiveValue():string {
        return this.primitiveValueForKey('productID');
    }

    // Relationship: serviceChargeRuleFormats
    protected _serviceChargeRuleFormats:MIOManagedObjectSet = null;
    get serviceChargeRuleFormats():MIOManagedObjectSet {
        return this.valueForKey('serviceChargeRuleFormats');
    }
    addServiceChargeRuleFormatsObject(value:ServiceChargeRuleFormat) {
        this._addObjectForKey(value, 'serviceChargeRuleFormats');
    }
    removeServiceChargeRuleFormatsObject(value:ServiceChargeRuleFormat) {
        this._removeObjectForKey(value, 'serviceChargeRuleFormats');
    }
}
